import appConfig from 'app.config'
import { useTranslation } from 'react-i18next'

export const ContactForm = () => {
	const { t } = useTranslation()
	return {
		fieldSetName: '',
		formName: 'ContactForm',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'subject',
				type: 'text',
				label: t('Subject'),
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'body',
				type: 'textarea',
				label: t('Message'),
				visible: true,
				col: 12,
			},
		],
	}
}
